import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { updateUser } from '../../store/slices/userSlice';
import routes from '../../utils/routes';
import strings from '../../utils/strings';
import { CButton, CInput, CText, CHeader } from '../../components/common';
import { emailValidation } from '../../utils/validation';

const UserDetails: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const colors = useAppSelector((state) => state.theme.theme);
  const currentUser = useAppSelector((state) => state.user.user);

  const [fullName, setFullName] = useState(currentUser?.name || '');
  const [email, setEmail] = useState(currentUser?.email || '');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    let isValid = true;

    if (!fullName.trim()) {
      setNameError(strings.thisFieldIsMandatory);
      isValid = false;
    } else {
      setNameError('');
    }

    if (!email.trim()) {
      setEmailError(strings.thisFieldIsMandatory);
      isValid = false;
    } else if (!emailValidation(email)) {
      setEmailError(strings.enterValidEmail);
      isValid = false;
    } else {
      setEmailError('');
    }

    if (isValid) {
      setLoading(true);
      try {
        // Update user in Redux store
        dispatch(updateUser({
          name: fullName,
          email: email,
          user_exists: true
        }));

        // Navigate to home
        navigate(routes.home);
      } catch (error: any) {
        console.error('Error updating user details:', error);
        alert('Failed to update profile. Please try again.');
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div
      className="min-h-screen"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <CHeader title="Complete Profile" />

      {/* Responsive container */}
      <div className="max-w-md md:max-w-lg lg:max-w-xl mx-auto px-5 py-4">
        <h2
          className="text-2xl md:text-3xl font-bold mb-2"
          style={{ color: colors.textColor }}
        >
          Complete Your Profile
        </h2>
        <CText type="r14" color={colors.grayScale500} style={{ marginBottom: '16px' }}>
          Please provide your details to continue
        </CText>

        <CInput
          label={strings.fullName}
          value={fullName}
          onChange={setFullName}
          placeholder="Enter your full name"
          errorText={nameError}
          required
        />

        <CInput
          label={strings.email}
          value={email}
          onChange={setEmail}
          placeholder="Enter your email"
          type="email"
          errorText={emailError}
          required
        />

        <CButton
          title={loading ? 'Saving...' : 'Continue'}
          onPress={handleSubmit}
          disabled={loading}
        />

        <div className="text-center mt-4">
          <span
            className="text-sm cursor-pointer"
            style={{ color: colors.grayScale500 }}
            onClick={() => navigate(routes.home)}
          >
            Skip for now
          </span>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
